var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/custom_surgery.c145e6cd.png","uri@2x": __webpack_public_path__ + "static/media/custom_surgery.5d8f01e1.png","uri@3x": __webpack_public_path__ + "static/media/custom_surgery.cc20903b.png",
    width: 24,
    height: 24
});